import { extendTailwindMerge } from "tailwind-merge";
import { cx } from "tailwind-variants";

import { designSystemTwMergeConfig } from "./twMergeConfig";

const twMerge = extendTailwindMerge(designSystemTwMergeConfig.twMergeConfig);

/**
 * Merge class names with Tailwind-aware conflict resolution.
 * Uses the design-system twMerge config so token utilities such as
 * `font-tag-text` and `font-weight-tag` are not dropped as conflicts.
 */
export function cn(...classes: Parameters<typeof cx>): string {
    return twMerge(cx(...classes) ?? "");
}
